module.exports = __webpack_public_path__ + "static/media/paul-smith.926453b5.jpg";